import Box from "@/components/Box";
import Danger from "@/images/Danger";
import Group from "@/tpo/Group";
import Stack from "@/tpo/Stack";
import dayjs from "dayjs";

export default function PlannedSystemMaintenance() {
  return (
    <Box px={[20, 20, 40]} pb={80}>
      <Stack
        alignItems={["flex-start", "center", "center"]}
        maxWidth={760}
        stacked
        mx="auto"
        gap={[20, 20, 40]}
      >
        <Group alignItems={[null, null, "center"]} gap={[10, 10, 20]}>
          <Danger size={[40]} />
          <Box as="h2" fontFamily="gilroyBold" fontSize={[28, 28, 44]} lineHeight="1.3">
            Planned System Maintenance
          </Box>
        </Group>
        <Stack gap={20} alignItems={[null, "center", "center"]}>
          <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
            We&apos;re upgrading our server to improve platform stability.
          </Box>
          <Box textAlign={[null, "center", "center"]}>
            <Box fontFamily="gilroyBold" fontSize={[14, 14, 16]}>
              Scheduled maintenance window
            </Box>
            <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
              From: 7:00pm, Friday 27 June
            </Box>
            <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
              To: 3:00pm, Sunday 29 June
            </Box>
          </Box>
          <Box textAlign={[null, "center", "center"]}>
            <Box as="span" fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
              <span>During this time</span>{" "}
              <Box as="span" fontFamily="gilroyBold" fontSize={[14, 14, 16]}>
                stock order allocation will be unavailable.
              </Box>
            </Box>
          </Box>
          <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
            Order placement and access to test results will continue as normal.
          </Box>
          <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
            We recommend managing stock allocations ahead of this maintenance window.
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
}
